import { NavLink } from 'react-router';
import type { ComponentType } from 'react';
import { cn } from '@/lib/utils';

export interface NavItem {
  to: string;
  label: string;
  icon: ComponentType<{ size?: number; weight?: 'regular' | 'fill' }>;
  end?: boolean;
  badge?: number;
}

/**
 * Нижняя навигация. Стоит последним блоком каркаса AppFrame (не position: fixed):
 * на iPhone fixed + backdrop-filter при инерционной прокрутке «уезжает» со страницей.
 */
export function BottomNav({ items, label }: { items: NavItem[]; label: string }) {
  return (
    <nav aria-label={label} className="glass z-40 shrink-0 safe-bottom">
      <ul className="mx-auto flex max-w-xl">
        {items.map(({ to, label: text, icon: IconCmp, end, badge }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                cn(
                  'relative flex min-h-14 flex-col items-center justify-center gap-0.5 pt-2 text-xs font-medium',
                  'focus-visible:outline-2 focus-visible:outline-offset-[-4px] focus-visible:outline-accent-bg rounded-lg',
                  isActive ? 'text-accent' : 'text-secondary',
                )
              }
            >
              {({ isActive }) => (
                <>
                  <IconCmp size={24} weight={isActive ? 'fill' : 'regular'} />
                  <span>{text}</span>
                  {badge ? (
                    <span className="absolute top-1.5 left-1/2 ml-2 min-w-4 rounded-full bg-accent-bg px-1 text-center text-[10px] leading-4 text-on-accent tabular">
                      {badge}
                    </span>
                  ) : null}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
